<script lang="ts">
	// Genuine shadcn-svelte Dialog.Root (bits-ui). The Root holds no markup of its
	// own — it provides context; children render the trigger/content. RESTYLED
	// wrappers live in the sibling files. NO arbitrary `[..]` values.
	import { Dialog as DialogPrimitive } from "bits-ui";

	let { open = $bindable(false), ...restProps }: DialogPrimitive.RootProps = $props();
</script>

<DialogPrimitive.Root bind:open {...restProps} />
